export default __webpack_public_path__ + "static/media/user-checkmark.9cb72fc2.svg";